import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Line, { x1: "2", x2: "22", y1: "2", y2: "22", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M9.5 4h5L17 7h3a2 2 0 0 1 2 2v7.5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M14.121 15.121A3 3 0 1 1 9.88 10.88", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "CameraOff";
const CameraOff = memo(themed(Icon));
export {
  CameraOff
};
//# sourceMappingURL=camera-off.js.map
